import React from 'react';

import { Col, Row } from 'redpoints-front-components/index';

import { REPORT_TYPE } from './AllIncidents';
import AllIncidentsFiltersActions from './AllIncidentsFiltersActions';
import AllIncidentsFiltersAsset from './AllIncidentsFiltersAsset';
import AllIncidentsFiltersClosureDate from './AllIncidentsFiltersClosureDate';
import AllIncidentsFiltersConfirmationDate from './AllIncidentsFiltersConfirmationDate';
import AllIncidentsFiltersDeindexationStatus from './AllIncidentsFiltersDeindexationStatus';
import AllIncidentsFiltersDetectionDate from './AllIncidentsFiltersDetectionDate';
import AllIncidentsFiltersDomain from './AllIncidentsFiltersDomain';
import AllIncidentsFiltersEnforcementDate from './AllIncidentsFiltersEnforcementDate';
import AllIncidentsFiltersIncidentStatus from './AllIncidentsFiltersIncidentStatus';
import AllIncidentsFiltersLabel from './AllIncidentsFiltersLabel';
import AllIncidentsFiltersLinkStatus from './AllIncidentsFiltersLinkStatus';
import AllIncidentsFiltersNonEnforcementReasons from './AllIncidentsFiltersNonEnforcementReasons';
import AllIncidentsFiltersPriority from './AllIncidentsFiltersPriority';
import AllIncidentsFiltersProtectionType from './AllIncidentsFiltersProtectionType';
import AllIncidentsFiltersSearchLinkUrl from './AllIncidentsFiltersSearchLinkUrl';
import AllIncidentsFiltersSearchTerm from './AllIncidentsFiltersSearchTerm';

const AllIncidentsFilters = ({ reportType }) => {
  return (
    <div className="all-incidents-filters">
      <Row gutter={30} style={{ display: 'flex' }}>
        <Col span={6}>
          <AllIncidentsFiltersAsset reportType={reportType} />
        </Col>
        <Col span={6}>
          <AllIncidentsFiltersProtectionType />
        </Col>
        <Col span={6}>
          <AllIncidentsFiltersDomain />
        </Col>
        <Col span={6}>
          <AllIncidentsFiltersLabel reportType={reportType} />
        </Col>
      </Row>
      {reportType === REPORT_TYPE.INTERNAL ? (
        <>
          <Row gutter={30} style={{ display: 'flex' }} className="mt-20">
            <Col span={6}>
              <AllIncidentsFiltersDetectionDate />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersConfirmationDate />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersEnforcementDate />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersClosureDate />
            </Col>
          </Row>
          <Row gutter={30} style={{ display: 'flex' }} className="mt-20">
            <Col span={6}>
              <AllIncidentsFiltersIncidentStatus reportType={reportType} />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersLinkStatus reportType={reportType} />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersDeindexationStatus />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersSearchTerm />
            </Col>
          </Row>
          <Row gutter={30} style={{ display: 'flex' }} className="mt-20">
            <Col span={6}>
              <AllIncidentsFiltersSearchLinkUrl />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersPriority />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersNonEnforcementReasons />
            </Col>
          </Row>
          <Row gutter={30}>
            <Col span={18}>
              <AllIncidentsFiltersActions reportType={reportType} />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row gutter={30} style={{ display: 'flex' }} className="mt-20">
            <Col span={6}>
              <AllIncidentsFiltersDetectionDate />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersConfirmationDate />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersClosureDate />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersIncidentStatus reportType={reportType} />
            </Col>
          </Row>
          <Row gutter={30} style={{ display: 'flex' }} className="mt-20">
            <Col span={6}>
              <AllIncidentsFiltersLinkStatus reportType={reportType} />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersDeindexationStatus />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersSearchTerm />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersSearchLinkUrl />
            </Col>
          </Row>
          <Row gutter={30} style={{ display: 'flex' }} className="mt-20">
            <Col span={6}>
              <AllIncidentsFiltersPriority />
            </Col>
            <Col span={6}>
              <AllIncidentsFiltersNonEnforcementReasons />
            </Col>
          </Row>
          <Row gutter={30}>
            <Col span={18}>
              <AllIncidentsFiltersActions reportType={reportType} />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default AllIncidentsFilters;
